import { useEffect, useState } from "react";

const totalCardxPag = 18;

const usePokeNames = (): readonly [
  string[],
  () => void,
  () => void,
  number
] => {
  const [pokemonNames, setPokemonNames] = useState<string[]>([]);
  const [pagination, setPagination] = useState<number>(0);
  const [currentPage, setCurrentPage] = useState<number>(0);

  const getPokemonNames = async (offset = 0) => {
    const res = await fetch(
      `https://pokeapi.co/api/v2/pokemon?limit=${totalCardxPag}&offset=${offset}`
    );
    const resultado = await res.json();
    const pokeNames: string[] = [];
    resultado.results.map((poke: { name: string }) => {
      pokeNames.push(poke.name);
    });
    setPokemonNames(pokeNames);
    setPagination(resultado.count);
  };

  useEffect(() => {
    getPokemonNames(currentPage);
  }, [currentPage]);

  function nextPage() {
    setCurrentPage(previo =>
      previo + totalCardxPag < pagination ? previo + totalCardxPag : previo
    );
  }
  function previousPage() {
    setCurrentPage(previo =>
      previo - totalCardxPag < 0 ? previo : previo - totalCardxPag
    );
  }

  return [pokemonNames, nextPage, previousPage, currentPage] as const;
};

export default usePokeNames;
